import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ClusterInputState } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import { INPUT_STATES_QUERY_KEY } from "hooks/useInputsStates";
const startInput = async ({ inputId }) => ClusterInputState.start(inputId);
const stopInput = async ({ inputId }) => ClusterInputState.stop(inputId);
const setupInput = async ({ inputId }) => ClusterInputState.setup(inputId);
const useInputStateMutations = (input) => {
  const queryClient = useQueryClient();
  const startMutation = useMutation({
    mutationFn: startInput,
    onError: (error) => {
      UserNotification.error(
        `Error starting input '${input.title}': ${error}`,
        `Input '${input.title}' could not be started`
      );
    },
    onSuccess: () => {
      UserNotification.success("Input has been successfully started.", "Success!");
      queryClient.invalidateQueries({ queryKey: INPUT_STATES_QUERY_KEY });
    }
  });
  const stopMutation = useMutation({
    mutationFn: stopInput,
    onError: (error) => {
      UserNotification.error(
        `Error stopping input '${input.title}': ${error}`,
        `Input '${input.title}' could not be stopped`
      );
    },
    onSuccess: () => {
      UserNotification.success("Input has been successfully stopped.", "Success!");
      queryClient.invalidateQueries({ queryKey: INPUT_STATES_QUERY_KEY });
    }
  });
  const setupMutation = useMutation({
    mutationFn: setupInput,
    onError: (error) => {
      UserNotification.error(
        `Error entering setup mode '${input.title}': ${error}`,
        `Input '${input.title}' could not set to setup mode`
      );
    },
    onSuccess: () => {
      UserNotification.success("Input has been successfully deleted.", "Success!");
      queryClient.invalidateQueries({ queryKey: INPUT_STATES_QUERY_KEY });
    }
  });
  return {
    startInput: startMutation.mutateAsync,
    stopInput: stopMutation.mutateAsync,
    setupInput: setupMutation.mutateAsync
  };
};
export default useInputStateMutations;
